// extracted by css-extract-rspack-plugin
export default {"disable":"src-components-pages-global-complaint-detail-page-style-module__disable-oH9lNz","active":"src-components-pages-global-complaint-detail-page-style-module__active-Ww3qBo","ant-drawer":"src-components-pages-global-complaint-detail-page-style-module__ant-drawer-d8lvbP","antDrawer":"src-components-pages-global-complaint-detail-page-style-module__ant-drawer-d8lvbP","ant-drawer-body":"src-components-pages-global-complaint-detail-page-style-module__ant-drawer-body-HhTjcU","antDrawerBody":"src-components-pages-global-complaint-detail-page-style-module__ant-drawer-body-HhTjcU"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"disable\":\"src-components-pages-global-complaint-detail-page-style-module__disable-oH9lNz\",\"active\":\"src-components-pages-global-complaint-detail-page-style-module__active-Ww3qBo\",\"ant-drawer\":\"src-components-pages-global-complaint-detail-page-style-module__ant-drawer-d8lvbP\",\"antDrawer\":\"src-components-pages-global-complaint-detail-page-style-module__ant-drawer-d8lvbP\",\"ant-drawer-body\":\"src-components-pages-global-complaint-detail-page-style-module__ant-drawer-body-HhTjcU\",\"antDrawerBody\":\"src-components-pages-global-complaint-detail-page-style-module__ant-drawer-body-HhTjcU\"}";
        // 1793798895074
        var cssReload = require("../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  